import {
  submissionSchema,
  submissionSummarySchema,
} from '@billing/validation/submission';
import { Claim, Site } from 'interfaces';

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

export interface Submission {
  id: string;
  filename: string;
  uploaded: boolean;
  status: string;
  createdAt: string;
  siteID: string;
  payorID?: string | null | undefined;
  startingClaim?: string | null | undefined;
  claims?: Array<Claim> | null | undefined;
  cognitoID?: string;
  p1File: string | null;
  s3Path: string | null | undefined;
  submittedAt: string | null | undefined;
  totalAmount: string | null | undefined;
  site: Site | null | undefined;
}

export type UpdateSubmission = Optional<
  Submission,
  'filename' | 'uploaded' | 'status' | 'createdAt' | 'siteID' | 'claims'
>;

export type FormSubmission = Omit<Submission, 'id' | 'createdAt'>;

export interface CreateSubmission {
  uploaded: boolean;
  status: string;
  claims: any[];
  siteID: string;
  payorName: string;
  type: SubmissionType;
  autoSubmit: boolean;
  startDate?: string;
  endDate?: string;
  providerID?: string;
}

export interface SubmissionWithCount extends Submission {
  claimCount: number;
}

export const isSubmission = (obj: any): obj is Submission => {
  return submissionSchema.safeParse(obj).success;
};

export const isSubmissionWithCount = (
  obj: unknown
): obj is SubmissionWithCount => submissionSummarySchema.safeParse(obj).success;

export enum SubmissionType {
  ready = 'ready',
  date = 'date',
  provider = 'provider',
}

export enum SubmissionStatus {
  received = 'Received',
  cancelled = 'Cancelled',
  error = 'Error',
  generating = 'Generating',
  created = 'Created',
  pending = 'Pending',
  submitted = 'Submitted',
  submitting = 'Submitting',
  rejected = 'Rejected',
  reverted = 'Reverted',
}
